import BanTemplatesPage from "./BanTemplatesPage";


export default function WarnTemplatesPage() {
    return (
        <BanTemplatesPage
            apiPath="/settings/warnTemplates"
            pageTitle="Warn Templates"
            kindLabel="warn"
            allowDuration={false}
            flagKind="analyse"
        />
    )
}
